<template>
  <v-layout>
    <v-dialog v-model="dialogVisible" max-width="800px" @click:outside="closeDialog">
      <v-card>
        <v-card-title>
          <span class="headline">Historial de Estados</span>
        </v-card-title>

        <v-card-text>
          <div v-if="loading" class="text-center py-4">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>

          <div v-else-if="history.length === 0" class="text-center py-4">
            <v-icon large color="grey">history</v-icon>
            <p class="grey--text mt-2">No hay historial de estados disponible</p>
          </div>

          <v-data-table
            v-else
            :headers="headers"
            :items="history"
            :loading="loading"
            loading-text="Cargando..."
            :options="{
              descending: false,
              itemsPerPage: 15,
            }"
            :footer-props="{
              itemsPerPageOptions: [5, 10, 15, -1],
            }"
         
          >
            <template v-slot:item="{ item }">
              <tr>
                <td>  
                    <div class="status-badge font-weight-medium" :class="'status-' + (item.status.id || item.status)">
                    {{ item.status_name }}
                    </div>
                </td>
                <td>{{ (item.date) }}</td>
                <td>
                  <div>
                    <strong>{{ item.user.business_name }}</strong>
                    <div v-if="item.user.email" class="text-caption grey--text">{{ item.user.email }}</div>
                  </div>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeDialog">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { productionOrderService } from "@/libs/ws/productionOrderService";
import ProductionOrderStates from "@/constants/productionStates";
import { formatUtils } from "@/libs/utils/formatUtils";

export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    productionOrder: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      dialogVisible: false,
      history: [],
      loading: false,
      ProductionOrderStates: ProductionOrderStates,
      headers: [
        { text: "Estado", value: "status_name", align: "left", sortable: false },
        { text: "Fecha y Hora", value: "date", align: "left", sortable: false },
        { text: "Usuario", value: "user", align: "left", sortable: false },
      ],
    };
  },
  watch: {
    dialog(val) {
      this.dialogVisible = val;
      if (val && this.productionOrder) {
        this.loadHistory();
      }
    },
  },
  methods: {
    loadHistory() {
      if (!this.productionOrder || !this.productionOrder.id) {
        return;
      }

      this.loading = true;
      this.history = [];

      productionOrderService
        .getStatusHistory(this.productionOrder.id)
        .then((response) => {
          if (response.status) {
            this.history = response.result;
          } else {
            this.$toast.error(response.msg, "Error");
          }
        })
        .catch((e) => {
          console.log("Error loading status history", e);
          this.$toast.error("Error al cargar historial de estados", "Error");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    closeDialog() {
      this.dialogVisible = false;
      this.history = [];
      this.$emit("updateDialog", false);
    },
  },
};
</script>

<style scoped>
</style>
